import { NgModule } from '@angular/core';
import { TeamsRoutingModule } from './teams-routing.module';
import { TeamsService } from '@teams/infra';

@NgModule({
  imports: [TeamsRoutingModule],
  providers: [TeamsService]
})
export class TeamsModule {}
